import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getRippleFee } from "../app/ripple/rippleSlice"
import { RIPPLE } from "../constants/network"


function GetRippleFee() {
    const dispatch = useDispatch()

    const network = useSelector(state => state.network.network)
    const { data } = useSelector(state => state.ripple.fee)
    
    useEffect(() => {
        if (network === RIPPLE && !data) {
            dispatch(getRippleFee())
        }
    }, [network, data, dispatch])

    return null
}

export default GetRippleFee